import { Provider as JotaiProvider } from 'jotai';
import { useAtomsDevtools } from 'jotai-devtools';
import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import './App.css';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes/root';
import marketingApplicationStore from './store/markettingContentGeneration';
import BackgroundTaskManager from './components/widgets/BackGroundTaskManager';
import JotaiDebugHooks from './components/widgets/JotaiDebugHooks';
import { Toaster } from '@pfizer/shared/components';

// Create a client for react-query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

const shouldShowDebugger = import.meta.env.MODE === 'development';

function AppContent() {
  useAtomsDevtools('MyApp');

  useEffect(() => {
    // Force DevTools refresh after component mount
    if (shouldShowDebugger) {
      setTimeout(() => {
        // Trigger a re-render of DevTools
        window.dispatchEvent(new Event('jotai-devtools-refresh'));
      }, 1000);
    }
  }, []);

  return (
    <>
      {shouldShowDebugger && <JotaiDebugHooks />}
      <RouterProvider router={router} />
      <BackgroundTaskManager />
      <Toaster
        position='bottom-center'
        defaultDuration={5000}
        className='!z-[9999]'
      />
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <JotaiProvider store={marketingApplicationStore}>
        <AppContent />
      </JotaiProvider>
    </QueryClientProvider>
  );
}

App.displayName = 'App';
export default App;
